<template>
  <div class="landing-page">
    <div class="login-content">
      <div class="login login-send">
        <div class="logo-wrap">
          <img src="../../static/images/logo.png" alt="Bottle Pop">
        </div>
        <div class="middle">
          <img src="../../static/images/login_pic1.png" alt="Bottle Pop">
        </div>
        <div class="login-overlay">
          <div class="input-div">
            <div class="input-item">
              <div class="input-item2">

                <input ref="mobileInput" v-model="mobile" class="input" type="tel" maxlength="15"
                       inputmode="numeric" pattern="[0-9]*" :placeholder="$t('loginTips')"
                       @input="handleMobileInput">
              </div>
            </div>
          </div>
          <div class="login-list">
            <button class="drown-li login-button" type="button" @click="check_login">
              <span class="disflex day-en"><span class="btn-text">{{ $t('Login') }}</span></span>
            </button>
          </div>
        </div>
        <div class="login-footer">
          <div class="footer-link" @click="getChange('termsAndCondition')">{{ $t('TC') }}</div>
          <div class="footer-link" @click="getChange('faq')">{{ $t('FAQ') }}</div>
        </div>
      </div>
    </div>

    <Dialog ref="resubDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="resub-modal" slot="mdBox">
        <button class="resub-modal__close" type="button" @click="closeTmgDialog" aria-label="Close">
          <img src="../../static/images/close.png" alt="Close">
        </button>
        <div class="resub-modal__title">{{ $t('re_sub_tip') }}</div>
        <div class="resub-modal__actions">
          <button class="resub-modal__action resub-modal__action--subscribe" type="button" @click="goSub">
            <span>{{ $t('subscribe') }}</span>
          </button>
          <button class="resub-modal__action resub-modal__action--login" type="button" @click="goOtpLogin">
            <span>{{ $t('Login') }}</span>
          </button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '../components/dialog.vue'

export default {
  components: {Dialog},
  data() {
    return {
      isEN: 'bur',
      mobile: ''
    }
  },
  created() {
    if (localStorage.getItem('lang')){
      this.isEN = localStorage.getItem('lang')
    }
    if (this.$route.query.msidn) {
      this.mobile = this.dealPhone_2(this.$route.query.msidn)
    }else{
      let login_mobile = sessionStorage.getItem('login_mobile') || '';
      if (login_mobile) {
        this.mobile = this.dealPhone_2(login_mobile)
      }
    }
  },
  methods: {
    getChange(type) {
      this.$router.push({path: '/' + type})
    },
    handleMobileInput() {
      this.mobile = this.mobile.replace(/\D/g, '')
    },
    check_login() {
      let that = this
      if (this.mobile === '') {
        this.$utils.alertText(that.$t('loginTips'), 60)
        return
      }
      that.$parent.loadModal(true)
      const data = {
        mobile: that.getMobile(),
        device_id: that.getDeviceId()
      }
      that.$secureApi.post('/api/user/check_user', data, r => {
        if (r.code === 1) {
          that.$parent.loadModal(false);
          let token = r.data.userinfo.token;
          let mobile = r.data.userinfo.mobile;
          localStorage.setItem('token', token);
          localStorage.setItem('mobile', mobile);
          window.location.href = '/app';
        }else if (r.code === -2){
          that.goOtpLogin()
        }else if (r.code === -1){
          that.goSub()
        }
      });
    },
    userStatus() {
      const that = this
      if (that.mobile === '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return
      }
      const data = {
        mobile: that.getMobile(),
        device_id: that.getDeviceId()
      }
      that.$parent.loadModal(true)
      that.$secureApi.post('/api/user/user_status', data, r => {
        that.$parent.loadModal(false)
        that.$parent.returnCode(r, function () {
          if (r.code == 0) {
            that.$utils.alertText(r.msg, 80)
            return
          }
          if (r.data.status == 1 || r.data.status == -2) {
            that.goOtpLogin()
            return
          }
          if (r.data.status == 3 && r.data.valid == 'Y') {
            that.$refs.resubDialog.showMaskFun()
          } else {
            that.goSub()
          }
        })
      }, () => {
        that.$parent.loadModal(false)
        that.$utils.alertText(that.$t('system busy'), 80)
      })
    },
    goOtpLogin() {
      sessionStorage.setItem('login_mobile', (this.getMobile() || '').trim());
      this.$router.push({path: '/otp'})
    },
    goSub() {
      if (this.$refs.resubDialog){
        this.$refs.resubDialog.closeMask()
      }
      sessionStorage.setItem('login_mobile', (this.getMobile() || '').trim());
      this.$router.push({
        path: '/sub',
        query: this.buildCleanQuery({})
      })
    },
    getMobile() {
      return this.dealPhone(this.mobile)
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, '')
      if (phone.startsWith('0909') && phone.length === 13) phone = phone.substring(3)
      if (phone.startsWith('09') && phone.length === 11) phone = phone.substring(1)
      if (phone.startsWith('099') && phone.length === 12) phone = phone.substring(2)
      return phone
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, '')
      if (phone.startsWith('97') && phone.length === 10) phone = phone.substring(1)
      if (phone.startsWith('96') && phone.length === 10) phone = phone.substring(1)
      return phone
    },
    closeTmgDialog() {
      this.$refs.resubDialog.closeMask()
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id')
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)
        localStorage.setItem('device_id', id)
      }
      return id
    },
    buildCleanQuery(extra = {}) {
      const query = {};
      Object.keys(this.$route.query || {}).forEach(key => {
        if (!key || /^\d+$/.test(key)) {
          return;
        }
        const value = this.$route.query[key];
        if (value === undefined || value === null || value === '') {
          return;
        }
        if (Array.isArray(value)) {
          const values = value.filter(item => item !== undefined && item !== null && item !== '');
          if (values.length) {
            query[key] = values;
          }
          return;
        }
        query[key] = value;
      });
      delete query.mobile;
      delete query.mobileInput;
      delete query.msidn;
      delete query.subappid;

      Object.keys(extra).forEach(key => {
        const value = extra[key];
        if (value === undefined || value === null || value === '') {
          delete query[key];
          return;
        }
        query[key] = value;
      });

      return query;
    },
  }
}
</script>

<style scoped>
.landing-page {
  min-height: 100vh;
  background: url(../../static/images/land-bg.png) no-repeat center top;
  background-size: cover !important;
}

.logo-wrap {
  width: 100%;
  text-align: center;
}

.logo-wrap img {
  width: 35%;
  margin-top: 50px;
}

.middle img {
  top: clamp(118px, 28vw, 210px) !important;
}

.login-footer {
  position: relative;
  z-index: 3;
}

.login-overlay {
  margin-top: 220px;
  position: relative;
  z-index: 10;
}

.input-div .input-item {
  width: 86% !important;
  height: clamp(56px, 12vw, 90px) !important;
  margin: 0 auto !important;
  background: rgba(15, 52, 31, 0.82) !important;
  border-radius: 60px !important;
  box-shadow: inset 0 0 0 3px rgba(164, 255, 217, 0.18);
  --field-h: clamp(56px, 12vw, 90px);
}

.input-div .input-item2 {
  height: var(--field-h) !important;
  padding: 0 clamp(12px, 2.7vw, 20px) 0 clamp(5px, 1.1vw, 8px);
  border: 0 !important;
  border-radius: 60px !important;
}

.phone-prefix {
  flex: 0 0 auto;
  display: flex !important;
  align-items: center;
  margin-right: clamp(8px, 1.9vw, 14px);
  padding: 0 !important;
}

.phone-prefix img {
  width: clamp(66px, 12.7vw, 95px);
  height: auto;
  display: block;
}

.input-div input.input {
  flex: 1;
  min-width: 0;
  height: var(--field-h) !important;
  line-height: var(--field-h) !important;
  margin: 0 !important;
  padding: 0 clamp(14px, 3.2vw, 24px) !important;
  color: #fff !important;
/*  font-size: clamp(24px, 5.6vw, 42px) !important;*/
  font-weight: 700 !important;
  background: transparent !important;
  border-radius: 0 !important;
  box-sizing: border-box !important;
  font-size: clamp(30px, 6.4vw, 46px) !important;
}

.input-div input.input::placeholder {
  font-size: clamp(24px, 4.8vw, 36px) !important;
  line-height: var(--field-h) !important;
}

.input-div input.input::-webkit-input-placeholder {
  font-size: clamp(24px, 4.8vw, 36px) !important;
  line-height: var(--field-h) !important;
}

.login-list {
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin: clamp(20px, 5vw, 38px) auto 0;
}

.login-button {
  width: calc((86% - clamp(10px, 2.4vw, 18px)) / 2);
  padding: 0;
  border: 0;
  cursor: pointer;
}

.login-button .disflex {
  width: 100%;
  aspect-ratio: 309 / 162;
  justify-content: center;
  background-size: 100% 100% !important;
}

.login-button .btn-text {
  font-size: clamp(20px, 4vw, 30px);
}

.day-en {
  background: url(../../static/images/daily-bg_en.png) no-repeat center !important;
}

.login-footer {
  width: 70%;
  max-width: 520px;
  margin: clamp(24px, 5vw, 40px) auto 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-link {
  color: #8b4c12;
  font-size: clamp(18px, 4vw, 30px);
  font-weight: 900;
  white-space: nowrap;
  cursor: pointer;
}

.resub-modal {
  position: relative;
  width: min(580px, 96%);
  margin: 0 auto;
  padding: clamp(20px, 4.8vw, 34px) clamp(20px, 5vw, 38px) clamp(28px, 6vw, 44px);
  overflow: hidden;
  color: #fff;
  text-align: center;
  background: linear-gradient(165deg, rgba(43, 111, 56, 0.98) 0%, rgba(11, 57, 34, 0.99) 100%);
  border: 3px solid #fff1b3;
  border-radius: 30px;
  box-sizing: border-box;
  box-shadow: 0 18px 0 rgba(91, 57, 18, 0.38), 0 26px 56px rgba(27, 56, 21, 0.45), inset 0 0 0 3px rgba(255, 226, 112, 0.22);
}

.resub-modal__close {
  display: block;
  width: clamp(42px, 9vw, 58px);
  margin: -10px -12px 4px auto;
  padding: 0;
  line-height: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.resub-modal__close img {
  display: block;
  width: 100%;
}

.resub-modal__title {
  margin: 6px 0 clamp(20px, 4.6vw, 34px);
  color: #fff9d7;
  font-size: clamp(22px, 4.8vw, 34px);
  font-weight: 900;
  line-height: 1.25;
  text-shadow: 0 3px 0 rgba(44, 74, 22, 0.72);
}

.resub-modal__actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(10px, 2.4vw, 18px);
}

.resub-modal__action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(360px, 74vw);
  padding: 0;
  color: #fff;
  font-family: Atom-sans;
  font-size: clamp(22px, 4.8vw, 34px);
  font-weight: 900;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  border: 0;
  cursor: pointer;
  filter: drop-shadow(0 7px 9px rgba(32, 39, 9, 0.34));
  text-shadow: -2px -2px 0 #63208a, 2px -2px 0 #63208a, -2px 2px 0 #63208a, 2px 2px 0 #63208a;
}

.resub-modal__action:active {
  transform: translateY(1px);
}

.resub-modal__action--subscribe {
  aspect-ratio: 309 / 162;
  background-image: url(../../static/images/daily-bg_en.png);
}

.resub-modal__action--login {
  aspect-ratio: 276 / 145;
  background-image: url(../../static/images/week-bg_en.png);
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue